import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

export default class extends Controller {
  static targets = ["hintsPanel", "hintsContent", "hintsTitle"]
  static values = {
    canvasId: String
  }

  connect() {
    // Initialize canvas editor
  }

  showHints(event) {
    const button = event.currentTarget
    const hints = JSON.parse(button.dataset.hints || "[]")
    const blockName = button.dataset.blockName || "Block"

    if (this.hasHintsPanelTarget) {
      this.hintsTitleTarget.textContent = `${blockName} Hints`
      this.hintsContentTarget.innerHTML = hints
        .map(hint => `<li class="text-sm text-gray-600 mb-2">${hint}</li>`)
        .join("")
      this.hintsPanelTarget.classList.remove("hidden")
    }
  }

  closeHints() {
    if (this.hasHintsPanelTarget) {
      this.hintsPanelTarget.classList.add("hidden")
    }
  }

  async addCard(event) {
    const blockId = event.currentTarget.dataset.blockId
    const blockKey = event.currentTarget.dataset.blockKey

    // Create a temporary input for the new card
    const container = event.currentTarget.closest(".canvas-block").querySelector(".cards-container")
    const tempCard = document.createElement("div")
    tempCard.className = "canvas-card bg-white rounded p-2 shadow-sm border border-blue-300"
    tempCard.innerHTML = `
      <textarea
        class="w-full text-sm p-1 border-0 resize-none focus:ring-0 focus:outline-none"
        placeholder="Enter card content..."
        rows="2"
        data-action="blur->canvas-editor#saveNewCard keydown.enter->canvas-editor#saveNewCardOnEnter keydown.esc->canvas-editor#cancelNewCard"
        data-block-id="${blockId}"
      ></textarea>
    `
    container.appendChild(tempCard)

    const textarea = tempCard.querySelector("textarea")
    textarea.focus()
  }

  async saveNewCard(event) {
    const textarea = event.currentTarget
    const tempCard = textarea.closest(".canvas-card")

    // Prevent double submission
    if (tempCard.dataset.saving === "true") {
      return
    }

    const content = textarea.value.trim()
    const blockId = textarea.dataset.blockId

    if (!content) {
      this.cancelNewCard(event)
      return
    }

    // Mark as saving to prevent duplicate submissions
    tempCard.dataset.saving = "true"

    try {
      const response = await post("/workspace/canvas_cards", {
        body: JSON.stringify({
          canvas_card: {
            canvas_block_id: blockId,
            content: content
          }
        }),
        contentType: "application/json",
        responseKind: "json"
      })

      if (response.ok) {
        // Remove temp card — the real card arrives via Turbo Stream broadcast
        tempCard.remove()
      } else {
        const data = await response.json
        console.error("Failed to create card:", data.error)
        tempCard.dataset.saving = "false"
      }
    } catch (error) {
      console.error("Error creating card:", error)
      tempCard.dataset.saving = "false"
    }
  }

  saveNewCardOnEnter(event) {
    if (!event.shiftKey) {
      event.preventDefault()
      this.saveNewCard(event)
    }
  }

  cancelNewCard(event) {
    const textarea = event.currentTarget
    const tempCard = textarea.closest(".canvas-card")
    tempCard.remove()
  }
}
